import { branding, Colour_Tournament } from "./Utils";

export class CBChallengesComparison {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CBCHALLENGESCOMPARISON";
    this.scene = "CBCHALLENGESCOMPARISON";
    this.data = [];
    this.page = 7059;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      // if (options.push_up) {
      //   xml.payload.field.find((item) => {
      //     return item.attr.name === "0000";
      //   }).value = "1";
      // } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      } catch (err) {}
      // }

      // xml.payload.field.find((item) => {
      //   return item.attr.name === "005";
      // }).value =
      //   options.game?.home_team?.short_name +
      //   " v " +
      //   options.game?.away_team?.short_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value =
        options.game?.home_team?.variables?.alt_badge ||
        options.game?.home_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value =
        options.game?.away_team?.variables?.alt_badge ||
        options.game?.away_team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "0102";
      }).value =
        (options.game?.home_challenges?.successful ?? 0) +
        parseInt(
          options.game?.home_team?.variables?.successful_challenges ?? 0,
        );
      xml.payload.field.find((item) => {
        return item.attr.name === "0202";
      }).value =
        (options.game?.home_challenges?.unsuccessful ?? 0) +
        parseInt(
          options.game?.home_team?.variables?.unsuccessful_challenges ?? 0,
        );

      xml.payload.field.find((item) => {
        return item.attr.name === "0302";
      }).value =
        (options.game?.home_challenges?.inconclusive ?? 0) +
        parseInt(
          options.game?.home_team?.variables?.inconclusive_challenges ?? 0,
        );

      xml.payload.field.find((item) => {
        return item.attr.name === "0103";
      }).value =
        (options.game?.away_challenges?.successful ?? 0) +
        parseInt(
          options.game?.away_team?.variables?.successful_challenges ?? 0,
        );
      xml.payload.field.find((item) => {
        return item.attr.name === "0203";
      }).value =
        (options.game?.away_challenges?.unsuccessful ?? 0) +
        parseInt(
          options.game?.away_team?.variables?.unsuccessful_challenges ?? 0,
        );
      xml.payload.field.find((item) => {
        return item.attr.name === "0303";
      }).value =
        (options.game?.away_challenges?.inconclusive ?? 0) +
        parseInt(
          options.game?.away_team?.variables?.inconclusive_challenges ?? 0,
        );

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
